import React, { useState } from 'react';
import { addTeamMutation } from '../../../queries/queries';
import { useMutation } from '@apollo/client';
import { Button } from '../../../common/index';
import close from '../../../img/deelo_close.svg';
import removeCircle from '../../../img/remove-circle-icon.svg';

function ModalAddTeam(props) {
  const { associationId, isFirstTeam, setIsFirstTeam, setEditing, refetchTeam } = props;

  const [team, setTeam] = React.useState({
    name: '',
    adminEmails: [''],
    salesStartDate: '',
    salesEndDate: ''
  });

  const [step, setStep] = useState(0);
  const [graphQLError, setGraphQLError] = useState('');
  const [hasTeamAdmins, setHasTeamAdmins] = useState(false);

  const [addTeam] = useMutation(addTeamMutation, {
    variables: {
      associationId: associationId,
      name: team.name,
      adminEmails: hasTeamAdmins ? team.adminEmails.filter(email => email.trim() !== '') : [],
      salesStartDate: team.salesStartDate || null,
      salesEndDate: team.salesEndDate || null
    },
    onCompleted: (result) => {
      console.log('Team created successfully', result);
      setStep(2);
      setIsFirstTeam(false);
    },
    onError: (err) => {
      console.error('Error creating team:', err);
      setGraphQLError(err.message);
    }
  });

  const submitTeam = (e) => {
    e.preventDefault();
    addTeam();
  };

  return (
    <div className="open modal-form modal">
      <div className="box">
        <div className="close" onClick={() => setEditing('')}>
          <img src={close} alt="" />
        </div>

        {/* Step 1 - First team? */}
        {step === 0 && isFirstTeam ? (
          <>
            <h3 className='mb-lg'>Vi ser att det är första gången du lägger till ett lag</h3>
            <p>Om du är osäker på hur det fungerar när du lägger till ett lag kan du kolla videon på FAQ-sidan</p>
            <Button className='primary lg arrow' onClick={() => setStep(step + 1)}>Lägg till ett lag</Button>
            <Button className="bg-none" onClick={() => setEditing('')}>Avbryt</Button>
          </>
        ) : (step === 0 || step === 1) && (
          <>
            <h3 className='mb-lg'>Lägg till lag</h3>
            <form onSubmit={submitTeam}>
              {/* Team name */}
              <div className="form-row">
                <label htmlFor="name">Lagnamn *</label>
                <input
                  type="text"
                  name="name"
                  required
                  onChange={(e) => setTeam({ ...team, name: e.target.value })}
                  autoComplete="off"
                />
              </div>

              {/* Sales dates */}
              <div className="form-row">
                <label htmlFor="salesStartDate">Första försäljningsdag</label>
                <input
                  type="date"
                  name="salesStartDate"
                  value={team.salesStartDate}
                  onChange={(e) => setTeam({ ...team, salesStartDate: e.target.value })}
                  required
                />
              </div>

              <div className="form-row">
                <label htmlFor="salesEndDate">Sista försäljningsdag</label>
                <input
                  type="date"
                  name="salesEndDate"
                  value={team.salesEndDate}
                  onChange={(e) => setTeam({ ...team, salesEndDate: e.target.value })}
                  required
                />
              </div>

              {/* Admin emails */}
              {!hasTeamAdmins ? (
                <button
                  type="button"
                  className='bg-none m-0 email-increment btn-invite-team-admins'
                  onClick={() => {
                    setHasTeamAdmins(true);
                    setTeam({ ...team, adminEmails: [''] });
                  }}
                >
                  Lägg till lagledare +
                </button>
              ) : (
                <>
                  {team.adminEmails?.map((admin, index) => (
                    <div className="form-row relative" key={index}>
                      <label htmlFor="email">Lagledarens e-post *</label>
                      {index >= 0 && (
                        <Button
                          type="button"
                          onClick={() => {
                            const inputDecrement = [...(team.adminEmails || [])];
                            if (index === 0) {
                              setHasTeamAdmins(false);
                            } else {
                              inputDecrement.splice(index, 1);
                              setTeam({ ...team, adminEmails: inputDecrement });
                            }
                          }}
                          className='bg-none m-0 email-decrement'
                        >
                          <img src={removeCircle} alt="" />
                        </Button>
                      )}
                      <input
                        type="email"
                        required
                        placeholder="Lagledarens e-post"
                        name="email"
                        onChange={(e) => {
                          const updateAdminEmail = [...(team.adminEmails || [])];
                          updateAdminEmail[index] = e.target.value;
                          setTeam({ ...team, adminEmails: updateAdminEmail });
                        }}
                        autoComplete="off"
                      />
                    </div>
                  ))}

                  {/* Increment admin email */}
                  <Button
                    type="button"
                    onClick={() => {
                      setTeam({ ...team, adminEmails: [...(team.adminEmails || []), ''] });
                    }}
                    className='bg-none m-0 email-increment btn-invite-team-admins'
                  >
                    Lägg till fler lagledare +
                  </Button>
                </>
              )}

              {graphQLError && <p className="error form">{graphQLError}</p>}

              <button type="submit" className="lg primary">
                Lägg till lag
              </button>
            </form>
          </>
        )}

        {/* Step 2 - Success */}
        {hasTeamAdmins && step === 2 ? (
          <>
            <h3>Laget är tillagt!</h3>
            <p>{team.name}</p>
            {team.adminEmails?.filter(email => email.trim() !== '').map((email, index) => (
              <p key={index} className='m-0'>{email}</p>
            ))}
            <p className='m-0'>har fått ett konto skapat och information utskickat.</p>
            <Button className='secondary lg' onClick={() => setStep(0)}>Lägg till ett lag till +</Button>
            <Button className='primary lg' onClick={() => {
              setStep(0);
              setEditing('');
              refetchTeam();
            }}>Jag är klar</Button>
          </>
        ) : !hasTeamAdmins && step === 2 && (
          <>
            <h3>Laget är tillagt!</h3>
            <p className='mb-lg'>{team.name}</p>

            <Button className='secondary lg' onClick={() => setStep(0)}>Lägg till ett lag till +</Button>
            <Button className='primary lg' onClick={() => {
              setStep(0);
              setEditing('');
              refetchTeam();
            }}>Jag är klar</Button>
          </>
        )}
      </div>
    </div>
  );
}

export default ModalAddTeam;
